import { useEffect, useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Progress } from "@/components/ui/progress";

const PHASES = [
  { id: "orders", title: "Orders in hand", items: ["Send us your installation and report date", "Get pre-approved — ask your lender about V.A. loan eligibility", "Decide: buy, rent, or both", "Already own? Choose to sell or rent it out — we handle property management"] },
  { id: "leave", title: "Before house-hunting leave", items: ["Shortlist homes by distance to your base on our map", "Plan your house-hunting days with us", "Compare neighborhoods and schools near your commute"] },
  { id: "ground", title: "On the ground", items: ["Tour your shortlisted homes", "Make an offer — always offer less and ask for more!", "Inspection and appraisal"] },
  { id: "closing", title: "Closing & move-in", items: ["Lock your rate with your lender", "Final walk-through", "Get your keys and schedule household goods delivery"] },
];
const KEY = "757-pcs-checklist";
const TOTAL = PHASES.reduce((n, p) => n + p.items.length, 0);

export const PcsChecklist = () => {
  const [done, setDone] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  useEffect(() => localStorage.setItem(KEY, JSON.stringify(done)), [done]);
  const toggle = (id) => setDone((d) => (d.includes(id) ? d.filter((x) => x !== id) : [...d, id]));
  const pct = Math.round((done.length / TOTAL) * 100);

  return (
    <div data-testid="pcs-checklist">
      <div className="flex items-center gap-4">
        <Progress value={pct} className="h-2 flex-1 bg-neutral-200 [&>div]:bg-brass" data-testid="pcs-checklist-progress" />
        <span className="font-mono text-[12px] text-neutral-600" data-testid="pcs-checklist-count">{done.length}/{TOTAL} done</span>
      </div>
      <div className="mt-8 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
        {PHASES.map((p, pi) => (
          <div key={p.id} className="rounded-md border border-neutral-200 bg-white p-5">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-brass-deep">Phase {pi + 1}</p>
            <p className="mt-1 text-lg font-medium text-ink">{p.title}</p>
            <ul className="mt-4 space-y-3">
              {p.items.map((it, ii) => {
                const id = `${p.id}-${ii}`;
                return (
                  <li key={id}>
                    <label className="flex cursor-pointer items-start gap-3 text-[15px] leading-snug">
                      <Checkbox checked={done.includes(id)} onCheckedChange={() => toggle(id)} className="mt-0.5" data-testid={`pcs-check-${id}`} />
                      <span className={done.includes(id) ? "text-neutral-400 line-through" : "text-ink"}>{it}</span>
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};
